import { render, staticRenderFns } from "./AvgInformation.vue?vue&type=template&id=61359591&"
import script from "./AvgInformation.vue?vue&type=script&lang=js&"
export * from "./AvgInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports